import React, { FC } from 'react'

import styled from 'styled-components'

import EmptyIcon from 'src/Assets/Svg/common/empty.svg?react'

const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`
const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  width: 100%;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
export const BalanceEmptyList: FC = () => (
  <Container>
    <EmptyIcon />
    <Text>You haven't made any transactions yet</Text>
  </Container>
)
